import React from 'react';
import {connect} from "react-redux";
import {
    setGraph,
    setSelectedSymbolToTable,
    setRemoveSelectedSymbolToTable,
    clearSchematicListElements,
    refreshSchematicListElements,
    setActiveSize,
    setSchematicListElement,
    recreateSchematicsTabs
} from '../../store/Schematic_store/actions';
import styles from './GraphContainer.module.css';
import GraphPagination from "../Components/GraphPagination/GraphPagination";
import GraphFactoryService from "../services/GraphFactoryService";

class GraphContainer extends React.PureComponent {

    constructor(props) {
        super(props);
        this.graphRefWrapper = React.createRef();
    };

    componentDidMount() {
        this.setupGraph();
    }

    setupGraph() {
        const {setGraphToStore, activeSchematicType, gridStep, schematicDocument, symbolsTypes, clearSchematicListElements, recreateSchematicsTabs} = this.props;

        this.graph = GraphFactoryService.initEditor(this.graphRefWrapper.current, gridStep);
        GraphFactoryService.setupZoom(this.graph);
        this.setupSelectedCellListener(this.graph);
        this.setupListeners(this.graph);
        this.setupCellRemovedListener(this.graph);
        this.graph.setGridSize(gridStep);
        this.graph.validateViewBackground();
        setGraphToStore(this.graph);
        /**
         * If the is data to recreate
         */
        if (schematicDocument && symbolsTypes.length > 0) {
            this.graph.recreatePages(schematicDocument.data, activeSchematicType);
            recreateSchematicsTabs(this.graph.getActivePage().getData().elements);

            const pageSettings = this.graph.getActivePage().getPageSettings();
            if (pageSettings && pageSettings.scale && pageSettings.scrollOffset) {
                this.graph.setScale(pageSettings.scale);
                this.graph.setScrollOffset(pageSettings.scrollOffset);
            }
        } else {
            clearSchematicListElements();
        }
    }

    setupCellRemovedListener = (graph) => {
        graph.addListener(window.mxEvent.CELLS_REMOVED, (sender, evt) => {
            const {clearSchematicListElements, refreshSchematicListElements, schematicList} = this.props;
            const cells = evt.getProperty('cells');
            const cynySymbolsRemoved = cells.filter(c => c instanceof window.CYNYSymbol);
            const cellOnTheGraph = graph.getModel().getRoot().cellsByType.CYNYSymbol;

            if (!cellOnTheGraph.length) {
                clearSchematicListElements()
            } else {
                cynySymbolsRemoved.forEach(s => {
                    const isExist = cellOnTheGraph.find(c => c.symbolTypeId === s.symbolTypeId);
                    if (!isExist) {
                        const filteredSchematicList = schematicList.filter(t => t.id !== s.symbolTypeId);
                        refreshSchematicListElements(filteredSchematicList)
                    }
                });
            }
        });
    };

    componentDidUpdate(prevProps) {
        const {schematicDocument, gridStep, symbolsTypes} = this.props;
        if (prevProps.schematicDocument !== schematicDocument) {
            this.graph.destroy();
            this.setupGraph();
            const connectorData = symbolsTypes[0].symbols.find(symbol => symbol.isConnector);
            this.graph.setConnectorData(connectorData);
        }

        if (prevProps.gridStep !== gridStep) {
            this.graph.setGridSize(gridStep);
            this.graph.validateViewBackground();
        }

        if (prevProps.symbolsTypes !== symbolsTypes && symbolsTypes.length > 0) {
            const connectorData = symbolsTypes[0].symbols.find(symbol => symbol.isConnector);
            this.graph.setConnectorData(connectorData);
        }
    }

    setupSelectedCellListener = (graph) => {
        const {selectSymbolToStore, removedSymbol} = this.props;
        graph.selectionCellsHandler.addListener(window.mxEvent.ADD, (sender, me) => {
            const {cells} = sender.graph.getSelectionModel();
            const addCell = me.getProperty('state');
            if (addCell.cell && addCell.cell.shapeValue && cells.length === 1) {
                const properties = addCell.cell.shapeValue.SymbolProperties;
                selectSymbolToStore(properties);
            } else removedSymbol(null);
        });

        graph.selectionCellsHandler.addListener(window.mxEvent.REMOVE, (sender, me) => {
            const {cells} = sender.graph.getSelectionModel();
            if (!cells.length) {
                removedSymbol(null);
            } else if (cells.length === 1 && cells[0].shapeValue) {
                selectSymbolToStore(cells[0].shapeValue.SymbolProperties)
            }
        });
    };

    componentWillUnmount() {
        this.graph.manager.removeListener(this.undoRedoListener);
        this.graph.removeListener(this.paginationListener);
    }

    setupListeners = (graph) => {
        graph.addListener('ADD_PAGE', this.paginationListener);
        graph.addListener('REMOVE_PAGE', this.paginationListener);
        graph.addListener('SWITCH_PAGE', this.paginationListener);
        graph.manager.addListener(window.mxEvent.UNDO, this.undoRedoListener);
        graph.manager.addListener(window.mxEvent.REDO, this.undoRedoListener);
    };
    undoRedoListener = () => {
        const {scale, scrollOffset} = this.graph.getModel().getRoot().getPageSettings();
        this.graph.setScale(scale);
        this.graph.setScrollOffset(scrollOffset);
    };

    paginationListener = () => {
        this.pagination.refresh();
    };

    onAddPage = () => {
        this.graph.getActivePage().setData(this.graph.getActivePage().exportJson());
        this.graph.addPage();
        this.applyPageChange()

    };
    onRemovePage = () => {
        this.graph.removePage(this.graph.getActivePageIndex());
        this.applyPageChange();
    };
    onSwitchPage = (newPageIndex) => {
        const activePage = newPageIndex - 1;
        this.graph.setActivePage(activePage);
        this.applyPageChange();
    };

    resetActiveBackgroundShape = () => {
        const {activeSchematicType} = this.props;
        const backgroundShape = this.graph.getActivePage().getBackground();
        if (backgroundShape) {
            backgroundShape.updatePageInfo(this.graph.getActivePageIndex() + 1, this.graph.getPages().length);
            backgroundShape.updatePageTitle(activeSchematicType.name);
        }
    };

    applyPageChange = () => {
        const {recreateSchematicsTabs} = this.props;
        const data = this.graph.getActivePage().getData();
        if (data && data.pageSettings && data.pageSettings.scale && data.pageSettings.scrollOffset) {
            /**
             * Reset page settings
             */
            this.setPageSettings();
        } else {
            this.graph.getActivePage().setData({
                elements: [], pageSettings: {scale: this.graph.getScale(), scrollOffset: this.graph.getScrollOffset()}
            });
        }
        this.resetActiveBackgroundShape();
        this.pagination.refresh();
        recreateSchematicsTabs(this.graph.getActivePage().getData().elements);
    };
    setPageSettings = () => {
        const {scale, scrollOffset} = this.graph.getActivePage().getPageSettings();
        this.graph.setScale(scale);
        this.graph.setScrollOffset(scrollOffset);
    };

    onPaginationMount = (instance) => {
        this.pagination = instance;
    };

    render() {
        const {graph} = this.props;
        return (
            <div className={styles.pageContainer}>
                <div className={styles.graphWrapper} ref={this.graphRefWrapper}>
                </div>
                {graph && <GraphPagination
                    onMount={this.onPaginationMount}
                    removePage={this.onRemovePage}
                    addPage={this.onAddPage}
                    switchPage={this.onSwitchPage}
                />}
            </div>
        )
    }
}

function mapStateToProps({schematicReducers: {gridStep, schematicDocument, graph, schematicList, symbolsTypes, activeSchematicType}}) {
    return {
        activeSchematicType,
        symbolsTypes,
        gridStep,
        schematicList,
        schematicDocument,
        graph: graph.value,

    }
}

function mapDispatchToProps(dispatch) {
    return {
        setGraphToStore: (graph) => {
            dispatch(setGraph(graph))
        },
        selectSymbolToStore: (selectSymbol) => {
            dispatch(setSelectedSymbolToTable(selectSymbol))
        },
        removedSymbol: (removedSymbol) => {
            dispatch(setRemoveSelectedSymbolToTable(removedSymbol))
        },
        refreshSchematicListElements: (schematicUpdated) => {
            dispatch(refreshSchematicListElements(schematicUpdated))
        },
        clearSchematicListElements: () => {
            dispatch(clearSchematicListElements())
        },
        setGridStep: (gridStep) => {
            dispatch(setActiveSize(gridStep))
        },
        setSchematicElement: (schematicUpdated) => {
            dispatch(setSchematicListElement(schematicUpdated))
        },
        recreateSchematicsTabs: (elements) => {
            dispatch(recreateSchematicsTabs(elements))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GraphContainer);
